import { ProductInfoSource } from "~/components/StoreInfo/types";
import { useTranslation } from "react-i18next";
import styles from "./empty-reviews.module.css";

export const EmptyReviews = ({
  source,
  name



}: {source: ProductInfoSource;name: string;}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.emptyReviews}>
      <img
        src={"/prod/assets/web/catalogue/icons/hug.png"}
        alt={"store-icon"} />

      <div className={styles.content}>
        {source === ProductInfoSource.StoreInfoPage ?
        <h4>{t("reviews.emptyStoreReviews")}</h4> :

        <h4>{t("reviews.emptyProductReviews")}</h4>}

        {source === ProductInfoSource.StoreInfoPage &&
        <p>
            <span>{name}</span> {t("reviews.emptyStoreReviewsDescription")}
          </p>}

      </div>
    </div>);

};